/**
 * Minimal entry for SEO content pages.
 * Content is server-rendered in HTML — this mounts nav, link tree, and footer year.
 */
import './landing.css';
import './seo-content.css';
import '@/tailwind.css';
import { mountSeoPage } from './seo-page-mount';

mountSeoPage();
